import React, { useState, useEffect } from 'react';
import { ReviewInbox } from '../components/recovery/ReviewInbox';
import { ReviewManagement } from '../components/social-media/ReviewManagement';
import { WeeklyScorecard } from '../components/recovery/WeeklyScorecard';
import authenticatedFetch from '../utils/authenticatedFetch';
import { API_ENDPOINTS } from '../config/apiRouting';

const ReviewsPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'inbox' | 'management' | 'scorecard'>('inbox');
  const [selectedStore, setSelectedStore] = useState<string>('');
  const [storeName, setStoreName] = useState<string>('');
  const [stores, setStores] = useState<any[]>([]);

  useEffect(() => {
    loadStores();
  }, []);

  const loadStores = async () => {
    try {
      // Use recovery my-stores endpoint which returns only user's permitted stores
      const res = await authenticatedFetch(API_ENDPOINTS.recoveryMyStores());
      if (res.ok) {
        const data = await res.json();
        const storeList = data.stores || data || [];
        if (storeList.length > 0) {
          setStores(storeList);
          setSelectedStore(storeList[0].storeId);
          setStoreName(storeList[0].name || 'Store');
        }
      }
    } catch (e) {
      console.error('Failed to load stores', e);
    }
  };

  const handleStoreChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const storeId = e.target.value;
    setSelectedStore(storeId);
    const store = stores.find(s => s.storeId === storeId);
    setStoreName(store?.name || 'Store');
  };

  const tabs = [
    { key: 'inbox' as const, label: 'Review Inbox' },
    { key: 'management' as const, label: 'Review Platforms' },
    { key: 'scorecard' as const, label: 'Weekly Scorecard' },
  ];

  return (
    <div style={{ padding: '24px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
        <h1 style={{ fontSize: '24px', fontWeight: 700, margin: 0 }}>Reviews</h1>
        {stores.length > 1 && (
          <select
            value={selectedStore}
            onChange={handleStoreChange}
            style={{ padding: '8px 12px', borderRadius: '8px', border: '1px solid #d1d5db', fontSize: '14px' }}
          >
            {stores.map(s => (
              <option key={s.storeId} value={s.storeId}>{s.name}</option>
            ))}
          </select>
        )}
      </div>

      <div style={{ display: 'flex', gap: '4px', marginBottom: '24px', borderBottom: '2px solid #e5e7eb' }}>
        {tabs.map(tab => (
          <button
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            style={{
              padding: '10px 20px',
              border: 'none',
              background: 'none',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: activeTab === tab.key ? 600 : 400,
              color: activeTab === tab.key ? '#1976D2' : '#6b7280',
              borderBottom: activeTab === tab.key ? '2px solid #1976D2' : '2px solid transparent',
              marginBottom: '-2px',
            }}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {selectedStore && (
        <>
          {activeTab === 'inbox' && <ReviewInbox storeId={selectedStore} storeName={storeName} />}
          {activeTab === 'management' && <ReviewManagement storeId={selectedStore} storeName={storeName} />}
          {activeTab === 'scorecard' && <WeeklyScorecard storeId={selectedStore} />}
        </>
      )}
    </div>
  );
};

export default ReviewsPage;
